// styles
import './styles/graphic.scss';
import { classify } from './utils/helpers.js';

export default function (props, container, isMobile) {
  const {
    color,
    data,
    fmtYearAbbrev,
    fmtYearFull,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
  } = props;

  function replaceCharacter(val) {
    return val.replace(/_/g, ' ');
  }

  const xTicks = isMobile ? 5 : 5;
  const yTicks = isMobile ? 5 : 5;

  const xGrid = xAxis(x)
    .ticks(xTicks)
    .tickFormat(d => (isMobile
      ? `\u0027${fmtYearAbbrev(d)}`
      : fmtYearFull(d)));

  // legend
  container.insert('ul', ':first-child')
    .attr('class', 'key')
    .selectAll('li')
    .data(data)
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${color(d.id)};'></span> ${replaceCharacter(d.id)}`);

  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);

 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y).ticks(yTicks));

  // yGrid.select('text').style('display', 'none'); // hide first tick's text
  yGrid.selectAll('line').attr('x2', width);
  yGrid.selectAll('text')
    .text(d => `\u00A3${d / 1000}K`);

  g.append('rect')
    .attr('x', x(new Date('2007-12-01')))
    .attr('y', y(250000))
    .attr('height', height)
    .attr('width', x(new Date('2009-06-06')) - x(new Date('2007-12-01')))
    .style('fill', '#ccc')
    .style('opacity', 0.2);

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', d => `line-${classify(d.id)} line`);

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label');

  label.append('text')
    .attr('x', x(new Date('2007-12-01')) + 5)
    .attr('y', y(250000) + 15)
    .text('Global financial crisis')
    .attr('class', 'label-recession');

  label.append('text')
    .attr('x', x(new Date('2016-06-23')) + 5)
    .attr('y', y(250000) + 15)
    .text('Brexit referendum')
    .attr('class', 'label-recession');

  label.append('rect')
    .attr('x', x(new Date('2019-01-01')))
    .attr('y', y(160) - 2)
    .attr('width', 30)
    .attr('height', 5)
    .style('fill', 'white');

  label.append('line')
    .attr('x1', x(new Date('2016-06-26')))
    .attr('y1', y(250000))
    .attr('x2', x(new Date('2016-06-26')))
    .attr('y2', y(50000))
    .attr('class', 'dashed-line')
    .attr('stroke', 'black')
    .attr('stroke-opacity', 0.3)
    .style('stroke-dasharray', ('3, 3'))
    .style('stroke-width', 1);
  //  label.append('rect')
  //    .attr('x', x(new Date('2019-01-01')))
  //    .attr('y', y(160) - 2)
  //    .attr('width', 30)
  //    .attr('height', 5)
  //    .style('fill', 'white');
  //
  //  label.append('text')
  //    .attr('x', x(new Date('2019-01-01')) + 0)
  //    .attr('y', y(160) + 4.5)
  //    .text('jobs')
  //    .attr('class', 'grid-label')
  //    .style('fill', '#555')
  //    .style('font-weight', '300');

  label.append('text')
    // .attr('text-anchor', 'end')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 5;
      const y0 = y(d0.value) - 3;
      return `translate(${[x0, y0]})`;
    })
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      // return isMobile ? value.toFixed(1) : `${d.id}: ${value.toFixed(1)}`;
      return 'Q3: £224,337';
    });
}
